import { render, staticRenderFns } from "./CmRecent.vue?vue&type=template&id=6e952d84"
import script from "./CmRecent.vue?vue&type=script&lang=js"
export * from "./CmRecent.vue?vue&type=script&lang=js"
import style0 from "./CmRecent.vue?vue&type=style&index=0&id=6e952d84&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports